import axios from "axios"
import { CONST_API_PERSONNEL_DECLARATION_VOYANTS_ENDPOINT } from "../../../../../../endpoints"
import { IGetPersonnelsDeclarationsVoyantsRequestModel, IGetPersonnelsDeclarationsVoyantsResponseModel } from "./_models"

export function getPersonnelsDeclarationsVoyantsRequest(filters?: IGetPersonnelsDeclarationsVoyantsRequestModel) {
     return axios.post<IGetPersonnelsDeclarationsVoyantsResponseModel[]>(CONST_API_PERSONNEL_DECLARATION_VOYANTS_ENDPOINT, filters ? filters : {})
}
